import { useNavigate } from 'react-router';
import { Inbox, Plus } from 'lucide-react';

import { EmptyBlock } from '@/components/ui/empty-block';
import { Button } from '@/components/ui/button';

const ActionGroup = () => {
  const navigate = useNavigate();

  const onNewEscrow = () => navigate('/software-escrows/onboarding/new');

  const onLearnMore = () => window.open('https://codekeeper.co/software-escrow', '_blank');

  return (
    <div className="flex justify-center gap-3">
      <Button onClick={onNewEscrow}>
        <Plus /> New Escrow
      </Button>
      <Button variant="outline" onClick={onLearnMore}>
        Learn more
      </Button>
    </div>
  );
};

export const Intro = () => {
  return (
    <EmptyBlock
      icon={Inbox}
      title="No Software Escrows created yet"
      description={`Never lose access to your vital systems.\nStart a Software Escrow to secure all critical components of your on-premises application.`}
      action={<ActionGroup />}
      classes={{ title: 'text-base', card: 'h-full [&>div]:h-full', content: 'h-full flex flex-col justify-center' }}
    />
  );
};

export default Intro;
